// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UzEZ","colMin":"styles_colMin__1C8Qy"};